import * as React from "react";
import AppointmentFaqContainer from "../../../../../../../../../components/AppointmentFaq/v3/components/AppointmentFaq/AppointmentFaqContainer.js";
import AppointmentTypesContainer from "../../../../../../../../../components/AppointmentTypes/v3/components/AppointmentTypes/AppointmentTypesContainer.js";
import { getBookAppointmentStore } from "../../../../../../../data/v3/pages/BookAppointment/data/book-appointment-store-by-id.js";
import { getBookAppointmentType } from "../../../../../../../data/v3/pages/BookAppointment/data/book-appointment-type.js";
import { MissingStoreIdError, AlternativeUrlStoreError, InvalidVirtualAppointmentError, StoreNotFoundError, TypeNotFoundError, TypeNotAvailableForStoreError, LinkedAppointmentTypeNotValidError, AlternativeLinkedAppointmentTypeNotValidError } from "../../../../../../../v3/pages/BookAppointment/errors.js";
import { getFormattedParams, hasValidVirtualAppointmentParams, hasInvalidVirtualAppointmentParams, isAppointmentTypeValid } from "../../../../../../../v3/pages/BookAppointment/utils.js";
const WhatRoot = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(AppointmentTypesContainer, null), /* @__PURE__ */ React.createElement(AppointmentFaqContainer, null));
WhatRoot.getServerSideProps = async (apolloClient, params, locale) => {
  const formattedParams = getFormattedParams(params);
  if (formattedParams.globalStoreId === void 0) {
    throw MissingStoreIdError();
  }
  if (formattedParams.alternativeUrlStores?.includes(formattedParams.globalStoreId)) {
    throw AlternativeUrlStoreError();
  }
  if (hasValidVirtualAppointmentParams(formattedParams) || hasInvalidVirtualAppointmentParams(formattedParams)) {
    throw InvalidVirtualAppointmentError();
  }
  const [store, type] = await Promise.all([
    getBookAppointmentStore(
      apolloClient,
      formattedParams.globalStoreId,
      locale,
      formattedParams.tryInStoreFlow,
      formattedParams.groupId
    ),
    getBookAppointmentType(apolloClient, formattedParams.typeId, locale)
  ]);
  if (!store) {
    throw StoreNotFoundError();
  } else if (formattedParams.typeId && !type) {
    throw TypeNotFoundError();
  } else if (type && !isAppointmentTypeValid({
    typeId: type?.id,
    store
  })) {
    throw TypeNotAvailableForStoreError();
  } else if (formattedParams?.linkedAppointmentTypeId && !isAppointmentTypeValid({
    typeId: formattedParams?.linkedAppointmentTypeId,
    store
  })) {
    throw LinkedAppointmentTypeNotValidError();
  } else if (formattedParams?.alternativeLinkedAppointmentTypeId && !isAppointmentTypeValid({
    typeId: formattedParams?.alternativeLinkedAppointmentTypeId,
    store
  })) {
    throw AlternativeLinkedAppointmentTypeNotValidError();
  }
  return Promise.resolve({
    store,
    type,
    timeSlot: null
  });
};
export {
  WhatRoot as default
};
//# sourceMappingURL=WhatRoot.js.map
